import { AipIds } from '@harvestiq/constants';
import { z } from '@harvestiq/zod';
import { createFmhLgmEndorsementSchema } from '@harvestiq/external-clients-fmh-common';
import { lgmDetailsMarketingMonthsSchema } from '../coverages/coverage-details';

const submitFmhLgmCoverageReqSchema = z.object({
  orgId: z.string(),
  orgSchema: z.string(),
  aip: z.nativeEnum(AipIds),
  coverageId: z.string().uuid(),
  insuredUserId: z.string().uuid(),
  agentUserId: z.string().uuid(),
  reinsuranceYear: z.number().int(),
  aipPolicyProducerKey: z.string(),
  aipInsuranceAgentKey: z.string(),
  aipInsuranceInForceKey: z.string(),
  endorsementRequest: createFmhLgmEndorsementSchema,
  marketingMonths: z.array(lgmDetailsMarketingMonthsSchema),
});

export const submitFmhLgmCoverageMsgSchema = z.object({
  orgId: z.string(),
  request: submitFmhLgmCoverageReqSchema,
});

export type SubmitFmhLgmCoverageMsg = z.infer<
  typeof submitFmhLgmCoverageMsgSchema
>;
